import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Button } from 'reactstrap'
import EmailIcon from '../../../assets/img/svg/email-icon.svg'
import CallIcon from '../../../assets/img/svg/call-icon.svg'
import MapIcon from '../../../assets/img/svg/map-icon.svg'
import SSNIcon from '../../../assets/img/ssn_no.png'
import HouseIcon from '../../../assets/img/svg/house-icon.svg'
import CleanIcon from '../../../assets/img/svg/clean-icon.svg'
import CloseIcon from '../../../assets/img/svg/close-icon.svg'
import DocumentsImg from '../../../assets/img/document.png'
import ViewImg from '../../../assets/img/svg/view-file-icon.svg'
import { defaultUserImg } from '../../../helper/imagepath'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../../context/spinnerContext'
import {
  cleanerAllDetails,
  deleteCleanerNew,
  endCleanerContract,
  getAllCleanersReviews,
  getCleanerByID,
  getCleanerCalendarData,
  getCleanerSignatures,
  getCleanningDetails,
  getCleanningHistoryDetails,
  getDayOffDetails,
  reActivateCleanerContract,
  resendSignatureRequest,
  updateContractApproval
} from '../../../redux/slices/cleanersSlice'
import { getAllRegion, selectCleanerRegion } from '../../../redux/slices/regionSlice'
import { getSchedulePropertyDataById } from '../../../redux/slices/propertySlice'
import { errorToast, successToast } from '../../../util/Toast/toast'
import CustomModal from '../../../component/customModal'
import DeletePopup from '../../../component/deletePopup'
import EditCleaner from '../editCleaner'
import AddStrike from './addStrike'
import AddNotes from './addNotes'
import FullCalendarView from '../../../component/fullCalendar'
import {
  appendImageURL,
  convertTimestampToTimeWithTimezone,
  getDayStartAndEndTimestamps,
  getUserRole,
  hasAccess,
  maskPhoneNumber,
  getTimeStamp,
  convertTimestampToDateWithTimezone,
  checkIfPastDate,
  formatBookingForDisplay,
  getBookingDayjs
} from '../../../helper/function'
import { Tab, Tabs } from 'react-bootstrap'
import CommonReviewSlider from '../../../component/sliders/commonReviewSlider'
import RatingDisplay from '../../../component/rating'
import CleanningTabView from './cleanningTabView'
import StatusModal from '../../../component/modal/statusModal'
import ScheduledModalContent from '../../../component/scheduleStatus/scheduledModalContent'
import CancelModalContent from '../../../component/scheduleStatus/canceleModalContent'
import { deleteSupervisorNote, getAllSupervisorNotesByCleanerId, getSupervisorNoteID } from '../../../redux/slices/supervisorSlice'
import Pagination from '../../../component/common/pagination'
import CleanerDeleteModal from '../../../component/modal/cleanerDeleteModal'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import Select from 'react-select'
import AddDocuments from './addDocument'
import ViewDocument from './viewDocument'
import DocumentationStatusBadge from '../../../component/common/DocumentationStatusBadge'


const CleanersInfo = () => {
  const { cleaner_id } = useParams()
  const calendarRef = useRef()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const methods = useForm({
    defaultValues: {
      cleanerProperty: [],
      region_id: ''
    }
  })
  const { watch, setValue } = methods
  const { changeLoader } = useContext(SpinnerContext)
  const { scheduledProperties } = useSelector((state) => state.property)
  const { cleanerInfo, cleanerReviews, historyTabInfo, cleanningTabInfo, cleanerCalendarData, dayOffTabInfo, cleanerAllDetailsList } = useSelector(
    ({ cleaners }) => cleaners
  )
  const { allRegion } = useSelector(({ region }) => region)

  useEffect(() => {
    if (cleanerInfo && !cleanerInfo?.region_name) {
      dispatch(getAllRegion())
    }
  }, [dispatch, cleanerInfo])

  useEffect(() => {
    if (cleanerInfo?.region_name && allRegion.length > 0) {
      const selectedRegion = allRegion.find((region) => region.region === cleanerInfo.region_name)
      if (selectedRegion) {
        setValue('region_id', selectedRegion.region_id)
      }
    }
  }, [cleanerInfo?.region_name, allRegion, setValue])
  const { notesData } = useSelector(({ notes }) => notes)
  const [dateRange, setDateRange] = useState(null)
  const [isRefresh, setIsRefresh] = useState(true)
  const [editCleanerData, setEditCleanerData] = useState(false)
  const [showStrikeModal, setShowStrikeModal] = useState(false)
  const toggleStrikeModal = () => setShowStrikeModal(!showStrikeModal)

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const openDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen)

  const [showModal, setShowModal] = useState(false)
  const toggleModal = () => setShowModal((prev) => !prev)

  const [showNotesModal, setShowNotesModal] = useState(false)
  const toggleNotesModal = () => setShowNotesModal(!showNotesModal)

  const [isCleanerInfoModalOpen, setIsCleanerInfoModalOpen] = useState(false)
  const toggleCleanerInfoModal = () => setIsCleanerInfoModalOpen(!isCleanerInfoModalOpen)

  const [showAddDocumentModal, setShowAddDocumentModal] = useState(false)
  const toggleAddDocumentModal = () => setShowAddDocumentModal(!showAddDocumentModal)

  const [deleteType, setDeleteType] = useState(null)

  const [page, setPage] = useState(1)
  const [tabActiveKey, setTabActiveKey] = useState('tabs1')
  const [loading, setLoading] = useState(false)
  const [chatUserId, setChatUserId] = useState(null)
  const [modalName, setModalName] = useState(null)
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false)
  const [viewDetail, setViewDetail] = useState(null)
  const [isNoteRefresh, setIsNoteRefresh] = useState(true)
  const [isEditId, setIsEditId] = useState(null)
  const [noteCurrPage, setNoteCurrPage] = useState(1)
  const itemsPerPage = tabActiveKey === 'tabs3' ? 6 : 4
  const [showDocuments, setShowDocuments] = useState(false)
  const [signedDocuments, setSignedDocuments] = useState({ w9: null, contract: null })

  const overFun = useMemo(() => {
    return viewDetail?.next_checkin_time
      ? checkIfPastDate(viewDetail?.next_checkin_time, false)
      : checkIfPastDate(viewDetail?.booking_date_time, true)
  }, [viewDetail?.booking_date_time, viewDetail?.next_checkin_time])

  const CALENDAR_EVENT = useMemo(() => {
    let item = []

    if (cleanerCalendarData?.scheduledProperties) {
      cleanerCalendarData?.scheduledProperties?.map((overview) => {
        const propertyTz = overview?.properties?.timezone || overview?.property_timezone
        const newData = {
          properties_id: overview?.property_schedule_id,
          title: overview?.properties?.property_name,
          status: overview?.booking_status,
          host_name: `${overview?.properties?.client?.first_name} ${overview?.properties?.client?.last_name}`,
          accepted: overview?.scheduleCleaners ? (overview?.scheduleCleaners?.is_accepted ? 'Accepted' : 'Declined') : 'Pending',
          checkout: (overview?.booking_wall_clock || overview?.booking_date_time)
            ? formatBookingForDisplay(overview, propertyTz, 'DD MMM YYYY hh:mm A')
            : null,
          next_check_in: overview?.next_checkin_time
            ? `${convertTimestampToDateWithTimezone(overview?.next_checkin_time, propertyTz)} ${convertTimestampToTimeWithTimezone(overview?.next_checkin_time, propertyTz)}`
            : null,
          date: (overview?.booking_wall_clock || overview?.booking_date_time)
            ? getBookingDayjs(overview, propertyTz)?.format('YYYY-MM-DD') || ''
            : '',
          cleaner_name: overview?.cleaners ? `${overview?.cleaners?.first_name} ${overview?.cleaners?.last_name}` : null
        }
        item.push(newData)
      })
    }
    return item
  }, [cleanerCalendarData])

  useEffect(() => {
    if (cleaner_id && isRefresh) {
      changeLoader(true)
      dispatch(getCleanerByID(cleaner_id))
        .then((response) => {
          if (response?.payload?.statusText === 'Not Found' && response?.payload?.status === 404) {
            navigate('/cleaners', { replace: true })
          }
        })
        .catch((err) => {
          console.error('Error fetching cleaner:', err)
          setIsRefresh(false)
        })
        .finally(() => {
          changeLoader(false)
          setIsRefresh(false)
        })
    }
  }, [cleaner_id, isRefresh])

  useEffect(() => {
    if (cleaner_id) {
      dispatch(getCleanerSignatures(cleaner_id))
        .then((response) => {
          const signatures = response?.payload?.data?.data?.signatures || []
          const signed = { w9: null, contract: null }
          signatures.forEach((sig) => {
            if (sig.status === 'signed' && sig.signed_document_url) {
              if (sig.document_type === 'w9' && !signed.w9) signed.w9 = sig.signed_document_url
              if (sig.document_type === 'contract' && !signed.contract) signed.contract = sig.signed_document_url
            }
          })
          setSignedDocuments(signed)
        })
        .catch(() => {})
    }
  }, [cleaner_id, dispatch])

  useEffect(() => {
    const { startOfDayTimestamp } = getDayStartAndEndTimestamps(getTimeStamp(dateRange?.start))
    const { endOfDayTimestamp } = getDayStartAndEndTimestamps(getTimeStamp(dateRange?.end))

    const params = {
      id: cleaner_id,
      data: {
        ...(dateRange?.start && { startTimestamps: dateRange?.start && startOfDayTimestamp }),
        ...(dateRange?.end && { endTimestamps: dateRange?.end && endOfDayTimestamp })
      }
    }
    if (dateRange?.start || dateRange?.end) {
      dispatch(getCleanerCalendarData(params))
        .then(() => {})
        .catch((err) => {
          console.error('Error fetching cleaner:', err)
          setIsRefresh(false)
        })
        .finally(() => {
          changeLoader(false)
          setIsRefresh(false)
        })
    }
  }, [dateRange])

  useEffect(() => {
    getTabDetails(cleaner_id)
  }, [cleaner_id, page, tabActiveKey, isRefresh])

  const clientName = useMemo(
    () => (viewDetail?.properties?.client ? viewDetail?.properties?.client?.first_name + ' ' + viewDetail?.properties?.client?.last_name : ''),
    [viewDetail]
  )

  const onDatasetChange = useCallback((arg) => {
    setDateRange({ start: arg.view.currentStart, end: arg.view.currentEnd })
  }, [])

  const getTabDetails = async (cleaner_id) => {
    changeLoader(true)
    setLoading(true)
    let payload = { id: cleaner_id, data: { page: page || 1, limit: itemsPerPage, isPagination: true } }
    try {
      if (tabActiveKey == 'tabs1') {
        dispatch(getCleanningDetails(payload))
          .then(() => {
            changeLoader(false)
            setLoading(false)
          })
          .catch((err) => {
            console.error('Error fetching cleaner:', err)
            changeLoader(false)
            setLoading(false)
          })
      } else if (tabActiveKey == 'tabs2') {
        dispatch(getCleanningHistoryDetails(payload))
          .then(() => {
            changeLoader(false)
            setLoading(false)
          })
          .catch((err) => {
            console.error('Error fetching cleaner:', err)
            changeLoader(false)
            setLoading(false)
          })
      } else if (tabActiveKey == 'tabs3') {
        dispatch(getDayOffDetails(payload))
          .then(() => {
            changeLoader(false)
            setLoading(false)
          })
          .catch((err) => {
            console.error('Error fetching cleaner:', err)
            changeLoader(false)
            setLoading(false)
          })
      } else {
        changeLoader(false)
        setLoading(false)
      }
    } catch (err) {
      console.error('Error fetching tab details:', err)
    }
  }

  const handlePageChange = (selectedItem) => {
    setPage(selectedItem.selected + 1)
  }

  const handlePagination = async (page) => {
    setPage(page)
  }

  //End contact
  const handleEndContarct = (data) => {
    setIsRefresh(false)
    changeLoader(true)
    let payload = { cleaner_id: cleaner_id, data: data }
    dispatch(endCleanerContract(payload))
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(true)
          isCleanerInfoModalOpen && toggleCleanerInfoModal()
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  const handleContarctApproval = (is_accepted) => {
    changeLoader(true)
    setIsRefresh(false)
    const payload = {
      data: { is_accepted: is_accepted },
      cleaner_id: cleaner_id
    }
    dispatch(updateContractApproval(payload))
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  const handleReactivateContract = () => {
    setIsRefresh(false)
    changeLoader(true)
    dispatch(reActivateCleanerContract(cleaner_id))
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  const handleRegionSelect = (regionId) => {
    if (!regionId) return
    changeLoader(true)
    dispatch(selectCleanerRegion({ id: cleaner_id, regionId }))
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Region selected successfully!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  const getCleanerAllDetails = (cleaner_id, type) => {
    dispatch(cleanerAllDetails(cleaner_id))
      .then((response) => {
        const data = response?.payload?.data?.data
        type !== 'end' && openDeleteModal()
        changeLoader(false)
        if (data?.properties?.length > 0 || data?.propertySchedules?.length > 0) {
          toggleCleanerInfoModal()
        } else {
          type == 'end'
            ? handleEndContarct({ properties: [], propertySchedules: [] })
            : deleteCleanerApi(cleaner_id, { properties: [], propertySchedules: [] })
        }
      })
      .catch(() => {})
  }
  const onDelete = () => {
    if (isEditId) {
      changeLoader(true)
      dispatch(deleteSupervisorNote(isEditId)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          notesData?.currentRecords === 1 && setNoteCurrPage(noteCurrPage - 1)
          openDeleteModal()
          setIsNoteRefresh(true)
          setIsEditId(null)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          openDeleteModal()
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    } else {
      if (cleaner_id) {
        changeLoader(true)
        getCleanerAllDetails(cleaner_id)
      }
    }
  }

  const onEndContact = () => {
    changeLoader(true)
    setDeleteType('end')
    getCleanerAllDetails(cleaner_id, 'end')
  }

  const deleteCleanerApi = (cleaner_id, data) => {
    let payload = { cleaner_id: cleaner_id, data: data }
    changeLoader(true)
    dispatch(deleteCleanerNew(payload)).then(({ payload, error }) => {
      if (payload?.status === 200) {
        changeLoader(false)
        isCleanerInfoModalOpen && toggleCleanerInfoModal()
        successToast(payload?.data?.status_message || 'Success!')
        if (payload?.data?.status_message === 'Cleaner Deleted successfully') {
          window.history.back()
          navigate('/cleaners', { replace: true })
        }
      } else {
        errorToast(payload?.data?.status_message || error?.message)
        changeLoader(false)
      }
    })
  }

  const onTabChange = (tabkey) => {
    setTabActiveKey(tabkey)
    setPage(1)
  }

  const onHandleDetails = useCallback(
    (data) => {
      setViewDetail(data)
      const { booking_status, property_schedule_id } = data
      setChatUserId(property_schedule_id)
      if (['scheduled', 'canceled', 'in progress', 'canceled cleaner']?.includes(booking_status)) {
        getPropertyData(property_schedule_id, booking_status)
      } else if (['completed']?.includes(booking_status)) {
        navigate(`/${`cleaner`}/complete-cleaning/${property_schedule_id}/cleaningDetail`)
      }
    },
    [navigate]
  )

  const getPropertyData = async (schedule_id, status) => {
    changeLoader(true)
    await dispatch(getSchedulePropertyDataById(schedule_id))
      .then(() => {
        setIsStatusModalOpen(true)
        setModalName(status)
        changeLoader(false)
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  const onDownloadW9Form = (url) => {
    try {
      const link = document.createElement('a')
      // eslint-disable-next-line no-undef
      link.href = `${process.env.REACT_APP_IMAGE_URL}${url}`
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } catch (err) {
      console.log('link download failed', err)
    }
  }

  const onDownloadSignedDocument = (url) => {
    try {
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } catch (err) {
      console.log('signed document download failed', err)
    }
  }

  useEffect(() => {
    if (!cleaner_id) {
      return
    }
    isNoteRefresh && getAllNotesInfo()
  }, [cleaner_id, isNoteRefresh])

  const handleNotePageChange = (selectedItem) => {
    setNoteCurrPage(selectedItem.selected + 1)
    setIsNoteRefresh(true)
  }

  const getAllNotesInfo = () => {
    let payload = {
      cleaners_id: cleaner_id,
      page: noteCurrPage || 1,
      limit: 5,
      sort_column: 'created_at',
      sort_order: 'DESC'
    }
    changeLoader(true)
    dispatch(getAllSupervisorNotesByCleanerId(payload))
      .then(() => {
        changeLoader(false)
        setIsNoteRefresh(false)
      })
      .catch(() => {
        changeLoader(false)
        setIsNoteRefresh(false)
      })
  }

  const onEditNotes = (id) => {
    setIsEditId(id)
    dispatch(getSupervisorNoteID(id))
      .then(() => {
        toggleNotesModal()
      })
      .catch((err) => {
        console.log('>>Err', err)
      })
  }

  useEffect(() => {
    if (cleanerAllDetailsList) {
      let properties = cleanerAllDetailsList?.properties?.map((item) => ({
        properties_id: item,
        cleaners_id: cleanerAllDetailsList?.cleaner
      }))
      let propertySchedules = cleanerAllDetailsList?.propertySchedules?.map((item) => ({
        properties_id: item,
        cleaners_id: cleanerAllDetailsList?.cleaner
      }))
      setValue('cleanerProperty', [{ properties }, { propertySchedules }])
    }
  }, [cleanerAllDetailsList])

  const onHandleUpdate = () => {
    const cleaningData = watch('cleanerProperty')
    let payload = []
    let propertiesData = []
    let propertySchedulesData = []
    if (Array.isArray(cleaningData[0]?.properties)) {
      const filteredProperties = cleaningData[0].properties
        .map(({ cleaners_id, properties_id }) => ({
          cleaners_id: cleaners_id?.cleaners_id,
          properties_id: properties_id?.properties_id
        }))
        .filter(({ cleaners_id }) => cleaners_id !== cleaner_id)
      propertiesData = { properties: filteredProperties || [] }
    }

    if (Array.isArray(cleaningData[1]?.propertySchedules)) {
      const filteredSchedules = cleaningData[1].propertySchedules
        .map(({ cleaners_id, properties_id }) => ({
          cleaners_id: cleaners_id?.cleaners_id,
          property_schedule_id: properties_id?.property_schedule_id
        }))
        .filter(({ cleaners_id }) => cleaners_id !== cleaner_id)
      propertySchedulesData = { propertySchedules: filteredSchedules || [] }
    }
    payload = { ...propertiesData, ...propertySchedulesData }
    deleteType == 'end' ? handleEndContarct(payload) : deleteCleanerApi(cleaner_id, payload)
  }

  const handleResendSignature = () => {
    changeLoader(true)
    dispatch(resendSignatureRequest(cleaner_id))
      .then(({ payload }) => {
        changeLoader(false)
        if (payload?.status === 200) {
          successToast(payload?.data?.status_message || 'Signature request resent successfully')
          setIsRefresh(true)
        } else {
          errorToast(payload?.data?.status_message || 'Failed to resend signature request')
        }
      })
      .catch(() => {
        changeLoader(false)
        errorToast('Failed to resend signature request')
      })
  }

  return (
    <div className="page-wrapper customers">
      <div className="content">
        {/* Header Title Start */}
        <div className="title_header">
          <h5 className="sec_title_text d-flex align-items-center" onClick={() => navigate(`/cleaners`)}>
            <i className="fa fa-angle-left fs-5 me-2" aria-hidden="true"></i>
            Back to Cleaners
          </h5>
          {hasAccess('cleanerEditAccess', getUserRole()) && (
            <>
              {cleanerInfo?.contract_status === 'accepted' ? (
                <div className="multiple_btn_div">
                  <Button
                    className="btn btn-primary btn-small"
                    type="button"
                    onClick={() => {
                      toggleStrikeModal()
                    }}
                  >
                    Strike Cleaner
                  </Button>
                  <Button
                    className="btn btn-red btn-small"
                    type="button"
                    onClick={() => {
                      onEndContact()
                    }}
                  >
                    End Contract
                  </Button>
                </div>
              ) : cleanerInfo?.contract_status === 'pending' ? (
                <div className="multiple_btn_div">
                  <Button
                    className="btn btn-primary btn-small"
                    type="button"
                    onClick={() => handleContarctApproval(true)}
                    disabled={!cleanerInfo?.region_name || !cleanerInfo?.city_name}
                  >
                    Aprove Contract
                  </Button>
                  <Button className="btn btn-red btn-small" type="button" onClick={() => handleContarctApproval(false)}>
                    Decline Contract
                  </Button>
                </div>
              ) : (
                cleanerInfo?.contract_status === 'completed' && (
                  <div className="multiple_btn_div">
                    <Button
                      className="btn btn-primary sky_btn btn-small"
                      type="button"
                      onClick={() => {
                        handleReactivateContract()
                      }}
                    >
                      Reactivate Contract
                    </Button>
                  </div>
                )
              )}
            </>
          )}
        </div>
        {/* Header Title End */}

        {/* User Details Start */}
        <div className="common_card_div mb-4">
          <div className="user_details_main_div">
            <div className="user_details_header">
              <div className="user_img_div">
                <div className="img_div">
                  <img
                    className="img-fluid"
                    src={cleanerInfo?.profile_image ? appendImageURL(cleanerInfo?.profile_image) : defaultUserImg}
                    alt="Image"
                  />
                </div>
                <div className="user_right_contains">
                  <h6>{cleanerInfo?.first_name ? `${cleanerInfo?.first_name} ${cleanerInfo?.last_name}` : 'N/A'}</h6>
                  <div className="review_star">
                    <RatingDisplay selectedValue={cleanerInfo?.rating} />
                  </div>
                  {cleanerInfo?.documentation_status && (
                    <div className="mt-2 d-flex align-items-center gap-2">
                      <DocumentationStatusBadge status={cleanerInfo.documentation_status} />
                      {(cleanerInfo.documentation_status === 'expired' || cleanerInfo.documentation_status !== 'completed') && hasAccess('cleanerEditAccess', getUserRole()) && (
                        <Button
                          className="btn btn-sm btn-outline-primary"
                          type="button"
                          onClick={handleResendSignature}
                        >
                          <i className="fa fa-refresh me-1" aria-hidden="true"></i>
                          Resend
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {hasAccess('cleanerEditAccess', getUserRole()) && (
                <div className="action_div justify-content-end">
                  <div
                    className="edit_btn_div me-2"
                    onClick={() => {
                      setEditCleanerData(cleanerInfo)
                      toggleModal()
                    }}
                  >
                    <i className="fas fa-edit"></i>
                  </div>
                  <div
                    className="delete_btn_div"
                    onClick={() => {
                      openDeleteModal()
                    }}
                  >
                    {/* <i className="fa fa-trash" aria-hidden="true"></i> */}
                    <i className="fas fa-trash-alt"></i>
                  </div>
                </div>
              )}
            </div>
            <div className="user_details_footer">
              <div className="left_sec_div">
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={EmailIcon} alt="Image" />
                  </div>
                  <h6>{cleanerInfo?.email ? cleanerInfo?.email : 'N/A'}</h6>
                </div>
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={CallIcon} alt="Image" />
                  </div>
                  <h6>{cleanerInfo?.phone_number ? maskPhoneNumber(cleanerInfo?.phone_number) : 'N/A'}</h6>
                </div>
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={MapIcon} alt="Image" />
                  </div>
                  <h6>
                    {cleanerInfo?.address
                      ? cleanerInfo?.address
                      : `${cleanerInfo?.city_name ?? cleanerInfo?.company_city ?? ''} ${cleanerInfo?.state ?? cleanerInfo?.company_state ?? ''} , ${cleanerInfo?.zip_code ?? cleanerInfo?.company_zip_code ?? ''}` ||
                        '-'}
                  </h6>
                </div>
                {hasAccess('cleanerSSN', getUserRole()) && (
                  <div className="user_details_box">
                    <div className="icon_box_div">
                      <img className="img-fluid" src={SSNIcon} alt="Image" style={{ width: 16, height: 16 }} />
                    </div>
                    <h6>
                      {cleanerInfo?.is_ssn || cleanerInfo?.is_ein
                        ? `${cleanerInfo?.is_ssn ? 'SSN : ' : ''} ${cleanerInfo?.is_ein ? 'EIN : ' : ''}`
                        : ''}
                      {cleanerInfo?.tax_identification_number ? cleanerInfo?.tax_identification_number : 'N/A'}
                    </h6>
                  </div>
                )}
              </div>
              <div className="right_sec_div">
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={HouseIcon} alt="Image" />
                  </div>
                  <h6>{cleanerInfo?.level ? cleanerInfo?.level : '0'} Level</h6>
                </div>
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={CleanIcon} alt="Image" />
                  </div>
                  <h6>{cleanerInfo?.total_cleaning ? cleanerInfo?.total_cleaning : '0'} Cleanings </h6>
                </div>
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={CloseIcon} alt="Image" />
                  </div>
                  <h6>{cleanerInfo?.strikes ? cleanerInfo?.strikes : '0'} Strikes </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* User Details End */}

        {/* Document and city Data Start */}

        <div className="mb-4">
          <div className="row">
            {hasAccess('cleanerDocuments', getUserRole()) && (
              <div className="col-md-6">
                <div className="common_heading_div">
                  <h4>Documents</h4>

                  {hasAccess('uploadCleanerDocument', getUserRole()) && (
                    <Button
                      className="btn btn-primary btn-small"
                      type="button"
                      onClick={() => {
                        toggleAddDocumentModal()
                      }}
                    >
                      Upload Document
                    </Button>
                  )}
                </div>
                <div className="common_card_div">
                  <div className="form-group img_grid_div">
                    <div className="image-preview-container">
                      {cleanerInfo?.id_verification_front && (
                        <img src={appendImageURL(cleanerInfo?.id_verification_front)} alt="preview" className="image-preview" />
                      )}
                    </div>
                    <div className="image-preview-container">
                      {cleanerInfo?.id_verification_back && (
                        <img src={appendImageURL(cleanerInfo?.id_verification_back)} alt="preview" className="image-preview" />
                      )}
                    </div>
                    {cleanerInfo?.w_nine_form_url && (
                      <div className="image-preview-container image-preview-container-doc">
                        <div style={{ cursor: 'pointer' }} onClick={() => onDownloadW9Form(cleanerInfo?.w_nine_form_url)}>
                          <div>
                            <img src={DocumentsImg} alt="preview" className="image-preview-doc" />
                          </div>
                          <label className="w9text">Download W9 Form</label>
                        </div>
                      </div>
                    )}
                    {signedDocuments.w9 && (
                      <div className="image-preview-container image-preview-container-doc">
                        <div style={{ cursor: 'pointer' }} onClick={() => onDownloadSignedDocument(signedDocuments.w9)}>
                          <div>
                            <img src={DocumentsImg} alt="preview" className="image-preview-doc" />
                          </div>
                          <label className="w9text">Signed W9</label>
                        </div>
                      </div>
                    )}
                    {signedDocuments.contract && (
                      <div className="image-preview-container image-preview-container-doc">
                        <div style={{ cursor: 'pointer' }} onClick={() => onDownloadSignedDocument(signedDocuments.contract)}>
                          <div>
                            <img src={DocumentsImg} alt="preview" className="image-preview-doc" />
                          </div>
                          <label className="w9text">Signed Contract</label>
                        </div>
                      </div>
                    )}
                    {(cleanerInfo?.documents || [])?.length > 0 && (
                      <div className="image-preview-container image-preview-container-doc">
                        <div style={{ cursor: 'pointer' }} onClick={() => setShowDocuments(true)}>
                          <div>
                            <img src={ViewImg} alt="preview" className="image-preview-doc" />
                          </div>
                          <label className="w9text">View All Documents</label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className={hasAccess('cleanerDocuments', getUserRole()) ? 'col-md-6' : 'col-md-12'}>
              <div className="common_heading_div">
                <h4 className="mt-3">Cities</h4>
              </div>
              <div className="common_card_div">
                <div className="form-group">
                  <label>Regions</label>
                  {hasAccess('selectRegion', getUserRole()) && (
                    <Controller
                      name="region_id"
                      control={methods.control}
                      render={({ field }) => (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Select
                            {...field}
                            className="react-selectcomponent form-control"
                            getOptionLabel={(option) => option.region || ''}
                            getOptionValue={(option) => option.region_id || ''}
                            options={allRegion || []}
                            isSearchable={true}
                            isClearable
                            placeholder="Select Region"
                            classNamePrefix="select_kanakku"
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption?.region_id || '')
                            }}
                            value={allRegion.find((region) => region.region_id === field.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-primary btn-small"
                            onClick={() => {
                              handleRegionSelect(field.value)
                            }}
                          >
                            Confirm
                          </button>
                        </div>
                      )}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Document and city Data End */}

        {/* Calendar Start */}
        <div className="mb-4">
          <div className="common_heading_div">
            <h4>Calendar</h4>
          </div>
          <div>
            <FullCalendarView
              calendarRef={calendarRef}
              onDatasetChange={onDatasetChange}
              CALENDAR_EVENT={CALENDAR_EVENT}
              setIsRefresh={setIsRefresh}
              height={650}
              maxEventsCount={3}
            />
          </div>
        </div>
        {/* Calendar End */}

        {/* Cleaning Start */}
        <div className="mb-4">
          <div className="common_tabs_main_div back_to_cleaners_tabs_div">
            <Tabs defaultActiveKey="tabs1" id="uncontrolled-tab-example" activeKey={tabActiveKey} onSelect={onTabChange}>
              <Tab eventKey="tabs1" title="Cleaning">
                <CleanningTabView
                  data={cleanningTabInfo || []}
                  loading={loading}
                  onHandleDetails={onHandleDetails}
                  pagination={{ handlePageChange, currentPage: page, itemsPerPage, totalRecords: cleanningTabInfo?.totalPage || 0 }}
                />
              </Tab>
              <Tab eventKey="tabs2" title="History">
                <CleanningTabView
                  data={historyTabInfo || []}
                  loading={loading}
                  onHandleDetails={onHandleDetails}
                  pagination={{ handlePageChange, currentPage: page, itemsPerPage, totalRecords: historyTabInfo?.totalPage || 0 }}
                />
              </Tab>
              <Tab eventKey="tabs3" title="Day Offs">
                <CleanningTabView
                  isDayOff={true}
                  data={dayOffTabInfo || []}
                  cleanerTimezone={dayOffTabInfo?.cleanerTimezone}
                  loading={loading}
                  onHandleDetails={onHandleDetails}
                  pagination={{ handlePageChange, currentPage: page, itemsPerPage, totalRecords: dayOffTabInfo?.totalPage || 0 }}
                />
              </Tab>
            </Tabs>
          </div>
        </div>
        {/* Cleaning End */}

        {/* Reviews Start */}
        <CommonReviewSlider
          id={cleaner_id}
          fetchReviews={getAllCleanersReviews}
          reviewDataSelector={() => cleanerReviews?.cleaningReviewData}
          profileImageSelector={(review) =>
            review?.propertySchedule?.properties?.client?.profile_image
              ? appendImageURL(review?.propertySchedule?.properties?.client?.profile_image)
              : defaultUserImg
          }
          nameSelector={(review) =>
            review?.propertySchedule?.properties?.client?.first_name
              ? `${review?.propertySchedule?.properties?.client?.first_name} ${review?.propertySchedule?.properties?.client?.last_name}`
              : `N/A`
          }
          totalRecords={cleanerReviews?.totalRecords}
        />
        {/* Reviews End */}

        {/* Payment and notes Data Start */}
        <div className="mb-0">
          <div className="row">
            <div className="col-md-12">
              <div className="common_heading_div">
                <h4>Supervisor Notes</h4>
                {hasAccess('superVisorNoteAction', getUserRole()) && (
                  <Button
                    className="btn btn-primary btn-small"
                    type="button"
                    onClick={() => {
                      setIsEditId(null)
                      toggleNotesModal()
                    }}
                  >
                    Add Note
                  </Button>
                )}
              </div>

              {notesData?.supervisorNotes?.length > 0 ? (
                notesData?.supervisorNotes?.map((item, index) => {
                  return (
                    <div className="common_card_div" style={{ marginBottom: '10px', padding: '10px' }} key={`note-${index}`}>
                      <div className="d-flex justify-content-between notes-wrap">
                        <div className="notes-list">{item?.description}</div>
                        <div className="d-flex justify-content-end me-2">
                          <div
                            className="edit_btn_div me-2"
                            onClick={() => {
                              const id = item?.supervisor_note_id
                              onEditNotes(id)
                            }}
                          >
                            <i className="fas fa-edit"></i>
                          </div>
                          <div
                            className="delete_btn_div"
                            onClick={() => {
                              const id = item?.supervisor_note_id
                              setIsEditId(id)
                              openDeleteModal()
                            }}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              ) : (
                <div className="common_card_div">
                  <div>No notes yet.</div>
                </div>
              )}

              {notesData?.totalRecords > 0 && (
                <Pagination currentPage={noteCurrPage} onPageChange={handleNotePageChange} totalPages={notesData?.totalPage} itemsPerPage={5} />
              )}
            </div>
          </div>
        </div>
        {/* Payment and notes Data End */}
      </div>

      {showStrikeModal && (
        <CustomModal isOpen={showStrikeModal} toggle={toggleStrikeModal} title={`Add Strike`} size="md">
          <AddStrike toggleStrikeModal={toggleStrikeModal} setIsRefresh={setIsRefresh} cleaner_id={cleaner_id} />
        </CustomModal>
      )}

      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger common-field-btn w-100"
              onClick={() => {
                onDelete()
              }}
            >
              Delete
            </button>
          </div>
        </DeletePopup>
      )}

      {showModal && (
        <CustomModal isOpen={showModal} toggle={toggleModal} title={`Edit Cleaner`} size={'md'}>
          <EditCleaner editCleanerData={editCleanerData} cleaner_id={cleaner_id} toggle={toggleModal} setIsRefresh={setIsRefresh} />
        </CustomModal>
      )}

      {showNotesModal && (
        <CustomModal isOpen={showNotesModal} toggle={toggleNotesModal} title={isEditId ? `Edit Note` : `Add Note`} size="md">
          <AddNotes toggleNotesModal={toggleNotesModal} setIsRefresh={setIsNoteRefresh} cleaner_id={cleaner_id} editId={isEditId} />
        </CustomModal>
      )}

      {showAddDocumentModal && (
        <CustomModal isOpen={showAddDocumentModal} toggle={toggleAddDocumentModal} title={`Upload Document`} size={'md'}>
          <AddDocuments toggleAddDocumentModal={toggleAddDocumentModal} setIsRefresh={setIsRefresh} cleaner_id={cleaner_id} />
        </CustomModal>
      )}
      {showDocuments && <ViewDocument showDocuments={showDocuments} setShowDocuments={setShowDocuments} images={cleanerInfo?.documents || []} />}

      {/* Modal open */}
      {isStatusModalOpen && (
        <StatusModal
          onClose={() => setIsStatusModalOpen(false)}
          title={`Cleaning #${scheduledProperties?.getPropertyScheduleData?.schedule_number}`}
          headerContent={{
            name: clientName,
            status: scheduledProperties?.getPropertyScheduleData?.booking_status
          }}
          chatUserId={chatUserId}
          CheckTimeOver={overFun}
          clientId={scheduledProperties?.getPropertyScheduleData?.properties?.client?.client_id}
        >
          {['canceled', 'canceled cleaner']?.includes(modalName) && (
            <CancelModalContent
              data={scheduledProperties?.getPropertyScheduleData}
              finalAmount={scheduledProperties?.finalAmount}
              onClose={() => setIsStatusModalOpen(false)}
            />
          )}
          {['scheduled', 'in progress']?.includes(modalName) && (
            <ScheduledModalContent
              data={scheduledProperties?.getPropertyScheduleData}
              setIsRefresh={setIsRefresh}
              onClose={() => setIsStatusModalOpen(false)}
              handlePagination={handlePagination}
              page={`cleaner`}
            />
          )}
        </StatusModal>
      )}

      <FormProvider {...methods}>
        {isCleanerInfoModalOpen && (
          <CleanerDeleteModal isOpen={isCleanerInfoModalOpen} toggleModal={toggleCleanerInfoModal} onHandleSubmit={onHandleUpdate} />
        )}
      </FormProvider>
    </div>
  )
}

export default CleanersInfo
